import PropTypes from "prop-types";
import React from "react";
const FormInputControls = React.lazy(() => import("../../forms/fieldsControl/FormInputControls"));

const FormInputCellComponent = ({
    id,
    name,
    cssClass = "",
    value,
    onChange,
    onBlur,
    placeholder = "",
    mainDivClass = "",
    iconConfig,
    handleClearClick,
    handleSearchClick
}) => {

    return (
        <FormInputControls id={id} name={name} cssClass={cssClass}
            value={value} onBlur={onBlur} onChange={onChange}
            fieldSetting={{
                placeholder: placeholder,
                mainDivClass: mainDivClass,
                iconConfig: iconConfig ??
                {
                    icon: "icon-park-outline:search", width: "18px", ttLabel: "Search", targetId: `search-icon`,
                    style: { cursor: 'pointer' }, onClick: handleSearchClick
                },
                // clearIconConfig: {
                //     icon: "ic:round-close",
                //     style: { cursor: 'pointer' },
                //     onClick: handleClearClick, ttLabel: "Clear", targetId: `clear`
                // }
            }} />
    );
};

FormInputCellComponent.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    cssClass: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    mainDivClass: PropTypes.string,
    iconConfig: PropTypes.object,
    handleClearClick: PropTypes.func,
    handleSearchClick: PropTypes.func
};

export const FormInputCell = React.memo(FormInputCellComponent);